import script from "./ObjectLens.vue?vue&type=script&setup=true&lang=js"
export * from "./ObjectLens.vue?vue&type=script&setup=true&lang=js"

import "./ObjectLens.vue?vue&type=style&index=0&id=3c345ece&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-3c345ece"]])

export default __exports__